<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">상품관리</span>
            <span class="txt">센터에서 이용 중인 이용권과 패키지를 등록 및 수정하고 설정할 수 있습니다.</span>
        </div>

        <div class="com-tab">
            <router-link :to="{ name: 'SettingGoodsUse' }">이용권 관리</router-link>
            <router-link :to="{ name: 'SettingGoodsPackage' }" class="on">패키지 관리</router-link>
            <router-link :to="{ name: 'SettingGoodsCategory' }">카테고리 관리</router-link>
        </div>

        <div class="sub-title-content">
            <span class="title">기본설정</span>
            <p class="info-txt">패키지 이용권의 이름과 금액 등 기본설정을 진행합니다.</p>
        </div>

        <div class="lesson-info-content top-info">
            <ul class="list">
                <li class="btn">
                    <button class="com-big-plus" @click="openPackagePop">
                        <span class="blind">더보기</span>
                    </button>
                </li>
                <li v-for="(item, index) in selectedProducts" :key="index">
                    <span class="icon-box">
                        <span
                            :class="'type-' + (ticketTypes.indexOf(item.cp_ticket_type_cd || item.ticketType) + 1)"
                            class="ico"
                        >
                            {{ ticketData[ticketTypes.indexOf(item.cp_ticket_type_cd || item.ticketType)] }}
                        </span>
                    </span>
                    <span
                        :class="'type-' + (ticketTypes.indexOf(item.cp_ticket_type_cd || item.ticketType) + 1)"
                        class="title"
                        @click="
                            selectedProduct = item.cp_center_prod_id || item.centerProductId;
                            packagePop = true;
                        "
                    >
                        {{ item.cp_namee || item.name }}
                    </span>
                    <span class="info">
                        {{ item.cp_less_cnt || item.lessonCount }}회 / 유효기간
                        {{ item.cp_period_cnt || item.periodCount
                        }}{{ (item.cp_period_type_cd || item.periodType) == 'M' ? '개월' : '일' }} /
                        {{
                            (
                                item.cp_category_temp_nm ||
                                (item.categorys || []).map((o) => o.name).join('|') ||
                                ''
                            ).replace(/\|/g, ' / ')
                        }}
                    </span>
                    <span class="num">
                        {{ (item.cp_sell_price || item.sellPrice) | numberFormatFilter }}
                        <small>원</small>
                    </span>
                    <button class="del" type="button" @click="removeFromSelectedProducts(index)">삭제</button>
                </li>
            </ul>
        </div>

        <form ref="package-form" class="com-table-wrap" @submit.prevent>
            <div class="com-card-input half-type full">
                <div class="line-box">
                    <div class="left-box">
                        <div class="line">
                            <span class="tit">
                                패키지명
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <input
                                    v-model="data.name"
                                    class="w540"
                                    placeholder="예 ) 필라테스 집중교육"
                                    required
                                    type="text"
                                />
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">패키지 설명</span>
                            <div class="input-cnt">
                                <input
                                    v-model="data.productComment"
                                    class="w540"
                                    placeholder="예) 코어필라테스, 복부필라테스를 만나보세요!"
                                    type="text"
                                />
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                정상가
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <input v-model="data.recvPrice" class="center w230" readonly type="text" />
                                <span class="txt">원</span>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                할인판매가
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <input v-model="data.sellPrice" class="center w230" required type="text" />
                                <span class="txt">원</span>
                            </div>
                        </div>
                    </div>
                    <div class="right-box">
                        <div class="line">
                            <span class="tit">
                                부가세
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <span class="tit">부가세</span>
                                        <p class="txt">
                                            설정한 부가세는 매출에 적용됩니다.
                                            <br />
                                            강사의 급여가 %인 경우, 부가세를 제외하고 정산하는 것은 강사개별급여
                                            설정에서 적용해주세요.
                                        </p>
                                    </div>
                                </div>
                            </span>
                            <div class="input-cnt">
                                <div class="com-radio">
                                    <input
                                        id="package-vat-no"
                                        v-model="data.vatYn"
                                        :value="false"
                                        name="package-vat-yn"
                                        type="radio"
                                    />
                                    <label for="package-vat-no">부가세 미적용</label>
                                </div>
                                <div class="com-radio">
                                    <input
                                        id="package-vat-yes"
                                        v-model="data.vatYn"
                                        :value="true"
                                        checked
                                        name="package-vat-yn"
                                        type="radio"
                                    />
                                    <label for="package-vat-yes">부가세 10% 적용</label>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                판매여부
                                <div class="com-tooltip">
                                    <button class="icon"></button>
                                    <div class="detail">
                                        <span class="tit">판매여부</span>
                                        <p class="txt">
                                            이용권 판매를 잠시 중단해야 하는 경우 '판매정지’를 선택하여 이용권 판매를
                                            중지할 수 있습니다.
                                            <br />
                                            추후 다시 '판매중'으로 변경 가능합니다.
                                        </p>
                                    </div>
                                </div>
                            </span>
                            <div class="input-cnt">
                                <div class="com-radio">
                                    <input
                                        id="package-use-yes"
                                        v-model="data.stockUseYn"
                                        :value="true"
                                        checked
                                        name="package-use-yn"
                                        type="radio"
                                    />
                                    <label for="package-use-yes">판매중</label>
                                </div>
                                <div class="com-radio">
                                    <input
                                        id="package-use-no"
                                        v-model="data.stockUseYn"
                                        :value="false"
                                        name="package-use-yn"
                                        type="radio"
                                    />
                                    <label for="package-use-no">판매정지</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="prodNo" class="line-gap">
                <div class="com-btn-area">
                    <div class="right-box">
                        <button class="com-btn red" type="button" @click="remove">삭제</button>
                    </div>
                </div>
            </div>

            <loading-spinner v-if="isLoading"></loading-spinner>
            <div v-else class="bottom-btn">
                <button class="com-btn" type="reset" @click="beforePage">취소</button>
                <button class="com-btn blue" type="submit" @click="save">수정</button>
            </div>
        </form>

        <!-- 등록 수강 설정 팝업 -->
        <goods-select-popup
            v-if="packagePop"
            :selectedProduct="selectedProduct"
            @select="select"
            @cancel-popup="cancelPopup"
        />
    </div>
</template>

<script>
import api from '../../../assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';
import GoodsSelectPopup from './GoodsPackageSelectPopup';

export default {
    name: 'SettingGoodsPackageEdit',
    components: { LoadingSpinner, GoodsSelectPopup },
    props: ['prodNo'],
    computed: {
        centerId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    data() {
        return {
            packagePop: false,
            isLoading: false,
            ticketData: [],
            ticketTypes: [],
            selectedProduct: '',
            selectedProducts: [],
            data: {},
        };
    },
    async beforeMount() {
        this.data = this.getDefault();

        (await this.$getSystemCode({ center_prod: ['ticket_type_cd'] })).forEach((o) => {
            this.ticketData = o.map((e) => e.codeDesc);
            this.ticketTypes = o.map((e) => e.codeName);
        });
    },
    mounted() {
        this.load();
    },
    methods: {
        getDefault() {
            return {
                recvPrice: 0,
                sellPrice: 0,
                vatYn: true,
                stockUseYn: true,
            };
        },
        select(item) {
            console.log(this.selectedProducts.length);
            if (this.selectedProducts.length >= 5) {
                alert('이용권은 최대 5까지만 등록할 수 있습니다.');
                return;
            }
            this.packagePop = false;
            this.selectedProducts.unshift(item);
            this.data.recvPrice = this.selectedProducts.reduce((s, o) => parseInt(s) + (parseInt(o.sellPrice) || 0), 0);
        },
        removeFromSelectedProducts(index) {
            if (confirm('선택된 상품을 패키지에서 제외하시겠습니까?')) {
                this.selectedProducts.splice(index, 1);
            }
        },
        load() {
            if (!this.prodNo) return;
            this.isLoading = true;
            api.get(`/admin/api/center/${this.centerId}/product/${this.prodNo}`, {
                params: {
                    ...this.$route.query,
                    limit: 1,
                    centerProductId: this.prodNo,
                },
            })
                .then((res) => {
                    this.isLoading = false;
                    this.data = res.data;
                    this.selectedProducts = res.data.packageCenterProducts || [];
                    console.log(this.data);
                })
                .catch((res) => {
                    this.isLoading = false;
                    this.data = this.getDefault();
                    if (res.response.status != 404 || this.prodNo) {
                        alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    }
                    console.error(res);
                });
        },
        save() {
            if (!this.$refs['package-form'].checkValidity() || this.isLoading) {
                (
                    this.$refs['package-form'].querySelector(':invalid') || {
                        focus() {},
                    }
                ).focus();
                return;
            }

            const error = false;

            if (error) return;

            this.data.productType = 'P';

            const data = {
                baseProduct: this.data,
                packageProducts: this.selectedProducts,
            };

            this.isLoading = true;
            (this.prodNo
                ? api.put(`/admin/api/center/${this.centerId}/product/package/${this.prodNo}`, data)
                : api.post(`/admin/api/center/${this.centerId}/product/package`, data)
            )
                .then((res) => {
                    this.isLoading = false;
                    alert('저장했습니다.');
                    if (this.prodNo) {
                        this.$router.push({ name: 'SettingGoodsPackage', query: this.$route.query });
                    } else {
                        this.$router.push({ name: 'SettingGoodsPackage' });
                    }
                })
                .catch((res) => {
                    this.isLoading = false;
                    alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
        remove(event) {
            if (!confirm('정말로 삭제하시겠습니까??')) {
                return;
            }
            event.target.disabled = true;
            api.delete(`/admin/api/center/${this.centerId}/product/${this.prodNo}`)
                .then((res) => {
                    alert('삭제했습니다.');
                    this.$router.push({ name: 'SettingGoodsPackage', query: this.$route.query });
                })
                .catch((res) => {
                    event.target.disabled = false;
                    alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
        beforePage() {
            // 이전페이지 이동
            this.$router.push({ name: 'SettingGoodsPackage' });
        },
        cancelPopup() {
            this.packagePop = false;
        },
        // 해당 함수는 이용권 등록과 관련된 팝업 창을 여는 함수입니다.
        openPackagePop() {
            if (this.selectedProducts.length >= 5) {
                alert('이용권은 최대 5개까지만 추가할 수 있습니다.');
                return;
            }
            this.selectedProduct = '';
            this.packagePop = true;
        },
    },
};
</script>
<style lang="scss"></style>
